// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.brand-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .brand-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .brand-page {
    padding: 16px 16px 28px;
  }
}

.brand-header {
  margin-bottom: 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
@media (max-width: 640px) {
  .brand-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
.brand-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.brand-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 640px) {
  .brand-header__title {
    font-size: 22px;
  }
}

.brand-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
}
.brand-breadcrumb li {
  display: flex;
  align-items: center;
}
.brand-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
}
.brand-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.brand-breadcrumb li a:hover {
  color: rgb(105, 190, 40);
}
.brand-breadcrumb li.brand-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.brand-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}
@media (max-width: 991px) {
  .brand-layout {
    grid-template-columns: 1fr;
  }
}

.brand-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: hidden;
}
.brand-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e7eaec;
  background: #f1f1f2;
}
.brand-card__header--accent {
  background: linear-gradient(135deg, rgba(105, 190, 40, 0.06), rgba(105, 190, 40, 0.02));
}
.brand-card__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.brand-card__title i {
  margin-right: 8px;
  color: rgb(105, 190, 40);
}
.brand-card__badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  background: rgba(105, 190, 40, 0.1);
  color: #52941f;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.brand-card__edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid rgba(0, 173, 208, 0.15);
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s ease;
}
.brand-card__edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.brand-card__body {
  padding: 24px;
}
.brand-card--preview .brand-card__body {
  padding: 32px 24px;
}

.brand-logo {
  margin-bottom: 20px;
}
.brand-logo img {
  width: 200px;
}
.brand-logo--centered {
  text-align: center;
  margin-bottom: 24px;
}

.brand-details__row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(231, 234, 236, 0.6);
}
.brand-details__row:last-child {
  border-bottom: none;
}
@media (max-width: 480px) {
  .brand-details__row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.brand-details__label {
  width: 140px;
  min-width: 140px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
}
.brand-details__label i {
  margin-right: 6px;
  font-size: 13px;
  color: rgb(105, 190, 40);
}
@media (max-width: 480px) {
  .brand-details__label {
    width: auto;
    min-width: auto;
  }
}
.brand-details__value {
  flex: 1;
  font-size: 14px;
  color: #676a6c;
  word-break: break-word;
}
.brand-details__value a {
  color: rgb(0, 173, 208);
  text-decoration: none;
  transition: color 0.15s ease;
}
.brand-details__value a:hover {
  color: #00839d;
  text-decoration: underline;
}
.brand-details__value--profile {
  display: flex;
  align-items: center;
  gap: 6px;
}
.brand-details__value--profile .profile_types {
  margin: 0;
}

.brand-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}
.brand-empty > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.brand-empty p {
  font-size: 15px;
  color: #676a6c;
  margin: 0 0 16px;
}

.brand-form__group {
  margin-bottom: 20px;
}
.brand-form__group--error .brand-form__input {
  border-color: rgb(245, 67, 89);
}
.brand-form__group--error .brand-form__input:focus {
  box-shadow: 0 0 0 3px rgba(245, 67, 89, 0.1);
}
.brand-form__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.brand-form__row {
  display: flex;
  gap: 12px;
}
@media (max-width: 480px) {
  .brand-form__row {
    flex-direction: column;
  }
}
.brand-form__input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 14px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.brand-form__input::placeholder {
  color: #ccc;
}
.brand-form__input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 3px rgba(105, 190, 40, 0.1);
}
.brand-form__input--select {
  appearance: auto;
  cursor: pointer;
}
.brand-form__error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: rgb(245, 67, 89);
  font-weight: 500;
}
.brand-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
  border-top: 1px solid #e7eaec;
}

.brand-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
}
.brand-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.brand-btn--primary:hover {
  background: #569c21;
}
.brand-btn--outline {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.brand-btn--outline:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.brand-btn--disabled {
  opacity: 0.5;
  pointer-events: none;
}

.brand-preview {
  text-align: center;
}
.brand-preview__info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.brand-preview__name {
  font-size: 18px;
  font-weight: 700;
  color: #6d6e71;
}
.brand-preview__profile {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #676a6c;
}
.brand-preview__profile .profile_types {
  margin: 0;
}
.brand-preview__org {
  font-size: 14px;
  color: #676a6c;
}
.brand-preview__link {
  font-size: 13px;
}
.brand-preview__link a {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.brand-preview__link a:hover {
  text-decoration: underline;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/my-branding/my-branding.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA3YA;EACE,uBAAA;EACA,iBAAA;AA8YF;AA7YE;EAHF;IAG8B,uBAAA;EAiZ5B;AACF;AAjZE;EAJF;IAI8B,uBAAA;EAqZ5B;AACF;;AAjZA;EACE,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAoZF;AAnZE;EANF;IAM8B,sBAAA;IAAwB,uBAAA;EAwZpD;AACF;AAvZE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AA4ZrD;AA1ZE;EACE,eAAA;EACA,gBAAA;EACA,cDeiB;ECdjB,SAAA;EACA,uBAAA;EACA,wED5BS;ACwbb;AA3ZI;EAPF;IAO8B,eAAA;EA+Z9B;AACF;;AA1ZA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AA6ZF;AA3ZE;EACE,aAAA;EACA,mBAAA;AA6ZJ;AA5ZI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDJzC;ACqapB;AAhaI;EAAI,cDZa;ECYe,qBAAA;EAAuB,4BAAA;AAqa3D;AArayF;EAAU,wBDxBnF;ACgchB;AAvaI;EAA8B,cDRb;ECQyC,gBAAA;AA2a9D;;AAraA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAwaF;AAvaE;EALF;IAK8B,0BAAA;EA2a5B;AACF;;AAvaA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA0aF;AAxaE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBDjCkB;AC2ctB;AAxaI;EACE,uFAAA;AA0aN;AAtaE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cD/CiB;ECgDjB,wEDxFS;ACggBb;AAvaI;EAAI,iBAAA;EAAmB,wBDlEX;AC6ehB;AAxaE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA0aJ;AAvaE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,mCAAA;EACA,uBD7FY;EC8FZ,eAAA;EACA,eAAA;EACA,0BAAA;AAyaJ;AAxaI;EAAU,4BDjGE;ECiG0B,WAAA;AA4a1C;AAzaE;EAAU,aAAA;AA4aZ;AAzaI;EAAoB,kBAAA;AA4axB;;AAtaA;EACE,mBAAA;AAyaF;AAxaE;EAAM,YAAA;AA2aR;AA1aE;EAAc,kBAAA;EAAoB,mBAAA;AA8apC;;AAxaE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;AA2aJ;AA1aI;EAAe,mBAAA;AA6anB;AA5aI;EANF;IAM8B,sBAAA;IAAwB,uBAAA;IAAyB,QAAA;EAkb/E;AACF;AAhbE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDnHiB;ACqiBrB;AAjbI;EAAI,iBAAA;EAAmB,eAAA;EAAiB,wBDrI5B;AC2jBhB;AArbI;EATF;IAS8B,WAAA;IAAa,eAAA;EA0b3C;AACF;AAxbE;EACE,OAAA;EACA,eAAA;EACA,cDhIiB;ECiIjB,sBAAA;AA0bJ;AAzbI;EAAI,uBDhJQ;ECgJe,qBAAA;EAAuB,4BAAA;AA8btD;AA9boF;EAAU,cAAA;EAAoC,0BAAA;AAkclI;AAhcI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAkcN;AAjcM;EAAiB,SAAA;AAocvB;;AA7bA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAgcF;AA/bE;EAAQ,eAAA;EAAiB,mBAAA;EAAqB,WD/I5B;ACmlBpB;AAncE;EAAI,eAAA;EAAiB,cDvJF;ECuJ8B,gBAAA;AAwcnD;;AAlcE;EACE,mBAAA;AAqcJ;AAncM;EAAqB,8BD3KT;ACinBlB;AArcM;EAA2B,4CAAA;AAwcjC;AApcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDtKiB;ECuKjB,kBAAA;AAscJ;AAncE;EACE,aAAA;EACA,SAAA;AAqcJ;AApcI;EAHF;IAG8B,sBAAA;EAwc9B;AACF;AAtcE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wED9NS;EC+NT,cD5LiB;EC6LjB,gBAAA;EACA,aAAA;EACA,wDAAA;AAwcJ;AAvcI;EAAiB,WDzLD;ACmoBpB;AAzcI;EAAU,+BD7ME;EC6M4B,6CAAA;AA6c5C;AA3cI;EACE,gBAAA;EACA,eAAA;AA6cN;AAzcE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBDxNc;ECyNd,gBAAA;AA2cJ;AAxcE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;AA0cJ;;AApcA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDxQW;ECyQX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AAucF;AArcE;EACE,6BDxPY;ECyPZ,WAAA;EACA,+BD1PY;ACisBhB;AAtcI;EAAU,mBAAA;AAycd;AAtcE;EACE,gBAAA;EACA,cDpPiB;ECqPjB,qBDvOW;AC+qBf;AAvcI;EAAU,mBD9OQ;EC8O0B,kBD/O5B;AC0rBpB;AAxcE;EACE,YAAA;EACA,oBAAA;AA0cJ;;AApcA;EACE,kBAAA;AAucF;AArcE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAucJ;AApcE;EACE,eAAA;EACA,gBAAA;EACA,cDzQiB;AC+sBrB;AAncE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDtRiB;AC2tBrB;AApcI;EAAiB,SAAA;AAucrB;AApcE;EACE,eAAA;EACA,cD5RiB;ACkuBrB;AAncE;EACE,eAAA;AAqcJ;AApcI;EAAI,uBD/SQ;EC+Se,qBAAA;AAwc/B;AAxcsD;EAAU,0BAAA;AA2chE;;AArcA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAwcF;;AArcA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAwcF;;AArcA;EAAY,mCAAA;EAAqC,UAAA;AA0cjD;;AAzcA;EAAY,mCAAA;EAAqC,qBAAA;EAAsB,UAAA;AA+cvE;;AA9cA;EAAY,mCAAA;EAAqC,mBAAA;EAAqB,UAAA;AAodtE;;AAndA;EAAY,mCAAA;EAAqC,qBAAA;EAAuB,UAAA;AAydxE;;AAvdA;EACE;IAAK,UAAA;EA2dL;EA1dA;IAAM,UAAA;EA6dN;EA5dA;IAAO,UAAA;EA+dP;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n// ─── Page Layout ──────────────────────────────────────────────────────────────\n\n.brand-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// ─── Header ───────────────────────────────────────────────────────────────────\n\n.brand-header {\n  margin-bottom: 28px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; }\n\n  &__title-row { display: flex; align-items: center; gap: 12px; }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n}\n\n// ─── Breadcrumb ───────────────────────────────────────────────────────────────\n\n.brand-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n\n  li {\n    display: flex;\n    align-items: center;\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; }\n    a { color: $body-content-color; text-decoration: none; transition: color 0.15s ease; &:hover { color: $develop-color; } }\n    &.brand-breadcrumb__current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n// ─── Layout ───────────────────────────────────────────────────────────────────\n\n.brand-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  align-items: start;\n  @media (max-width: 991px) { grid-template-columns: 1fr; }\n}\n\n// ─── Card ─────────────────────────────────────────────────────────────────────\n\n.brand-card {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 24px;\n    border-bottom: 1px solid $color-grey-1;\n    background: $color-neutral-light;\n\n    &--accent {\n      background: linear-gradient(135deg, rgba($develop-color, 0.06), rgba($develop-color, 0.02));\n    }\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    i { margin-right: 8px; color: $develop-color; }\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    height: 24px;\n    padding: 0 10px;\n    border-radius: 12px;\n    background: rgba($develop-color, 0.1);\n    color: darken($develop-color, 10%);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n  }\n\n  &__edit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 5px;\n    border: 1px solid rgba($clarify-color, 0.15);\n    background: rgba($clarify-color, 0.08);\n    color: $clarify-color;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.15s ease;\n    &:hover { background: $clarify-color; color: #fff; }\n  }\n\n  &__body { padding: 24px; }\n\n  &--preview {\n    .brand-card__body { padding: 32px 24px; }\n  }\n}\n\n// ─── Logo ─────────────────────────────────────────────────────────────────────\n\n.brand-logo {\n  margin-bottom: 20px;\n  img { width: 200px; }\n  &--centered { text-align: center; margin-bottom: 24px; }\n}\n\n// ─── View Mode Details ────────────────────────────────────────────────────────\n\n.brand-details {\n  &__row {\n    display: flex;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba($color-grey-1, 0.6);\n    &:last-child { border-bottom: none; }\n    @media (max-width: 480px) { flex-direction: column; align-items: flex-start; gap: 4px; }\n  }\n\n  &__label {\n    width: 140px;\n    min-width: 140px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $color-neutral-dark;\n    i { margin-right: 6px; font-size: 13px; color: $develop-color; }\n    @media (max-width: 480px) { width: auto; min-width: auto; }\n  }\n\n  &__value {\n    flex: 1;\n    font-size: 14px;\n    color: $body-content-color;\n    word-break: break-word;\n    a { color: $clarify-color; text-decoration: none; transition: color 0.15s ease; &:hover { color: darken($clarify-color, 10%); text-decoration: underline; } }\n\n    &--profile {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      .profile_types { margin: 0; }\n    }\n  }\n}\n\n// ─── Empty State ──────────────────────────────────────────────────────────────\n\n.brand-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  & > i { font-size: 36px; margin-bottom: 16px; color: $color-neutral-mid; }\n  p { font-size: 15px; color: $body-content-color; margin: 0 0 16px; }\n}\n\n// ─── Edit Form ────────────────────────────────────────────────────────────────\n\n.brand-form {\n  &__group {\n    margin-bottom: 20px;\n    &--error {\n      .brand-form__input { border-color: $implement-color; }\n      .brand-form__input:focus { box-shadow: 0 0 0 3px rgba($implement-color, 0.1); }\n    }\n  }\n\n  &__label {\n    display: block;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $color-neutral-dark;\n    margin-bottom: 6px;\n  }\n\n  &__row {\n    display: flex;\n    gap: 12px;\n    @media (max-width: 480px) { flex-direction: column; }\n  }\n\n  &__input {\n    width: 100%;\n    padding: 10px 14px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 14px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: #fff;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &::placeholder { color: $color-neutral-mid; }\n    &:focus { border-color: $develop-color; box-shadow: 0 0 0 3px rgba($develop-color, 0.1); }\n\n    &--select {\n      appearance: auto;\n      cursor: pointer;\n    }\n  }\n\n  &__error {\n    display: block;\n    margin-top: 4px;\n    font-size: 12px;\n    color: $implement-color;\n    font-weight: 500;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding-top: 8px;\n    border-top: 1px solid $color-grey-1;\n  }\n}\n\n// ─── Buttons ──────────────────────────────────────────────────────────────────\n\n.brand-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n    &:hover { background: darken($develop-color, 8%); }\n  }\n\n  &--outline {\n    background: #fff;\n    color: $body-content-color;\n    border-color: $color-grey-1;\n    &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n  }\n\n  &--disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n}\n\n// ─── Preview ──────────────────────────────────────────────────────────────────\n\n.brand-preview {\n  text-align: center;\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__name {\n    font-size: 18px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n  }\n\n  &__profile {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    color: $body-content-color;\n    .profile_types { margin: 0; }\n  }\n\n  &__org {\n    font-size: 14px;\n    color: $body-content-color;\n  }\n\n  &__link {\n    font-size: 13px;\n    a { color: $clarify-color; text-decoration: none; &:hover { text-decoration: underline; } }\n  }\n}\n\n// ─── Loader ───────────────────────────────────────────────────────────────────\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n#Path_129 { animation: blink 2s linear infinite; opacity: 0; }\n#Path_130 { animation: blink 2s linear infinite; animation-delay: .5s; opacity: 0; }\n#Path_132 { animation: blink 2s linear infinite; animation-delay: 1s; opacity: 0; }\n#Path_131 { animation: blink 2s linear infinite; animation-delay: 1.5s; opacity: 0; }\n\n@keyframes blink {\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  100% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
